import { render, staticRenderFns } from "./ProjectIntroduction.vue?vue&type=template&id=3309bf37&scoped=true"
import script from "./ProjectIntroduction.vue?vue&type=script&lang=js"
export * from "./ProjectIntroduction.vue?vue&type=script&lang=js"
import style0 from "./ProjectIntroduction.vue?vue&type=style&index=0&id=3309bf37&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3309bf37",
  null
  
)

export default component.exports